import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/providers/common.service';

@Component({
  selector: 'app-less-sales-merchantsv2',
  templateUrl: './less-sales-merchantsv2.component.html',
  styleUrls: ['./less-sales-merchantsv2.component.scss']
})
export class LessSalesMerchantsv2Component implements OnInit {

  constructor(public modal: NgbActiveModal, private ngbModal:NgbModal,private commonService: CommonService) { }
  LSMList:any;
  customDays: any;
  @Input() LSMResult :any;
  @Input() customLSMdays :any;
  buttonLoader: any= false;

  ngOnInit(): void {
    //console.log("this.NTTPNResult $$$$  ===> ", this.NTTPNResult);
    this.LSMList = this.LSMResult;
    this.customDays = this.customLSMdays;
  }

  downloadData(){
    this.buttonLoader = true;
    let fileName = "MerchantList.xlsx";
    let worksheetData = {
      "worksheet" : [
        {
          "name": 'Merchants List',
          "columns":  [
            // { header: "Merchant Id", key: "merchantId", width: 20 },
            { header: "Merchant dba", key: "merchantdba", width: 20 },
            { header: "Expected Avg", key: "AVG3Month", width: 10 },
            { header: "Last 7Days Avg", key: "AVG7Days", width: 10 },
            // { header: "Day1", key: "Day1", width: 10 },
            // { header: "Day2", key: "Day2", width: 10 },
            // { header: "Day3", key: "Day3", width: 10},
            // { header: "Day4", key: "Day4", width: 10},
            // { header: "Day5", key: "Day5", width: 10},
            // { header: "Day6", key: "Day6", width: 10},
            // { header: "Day7", key: "Day7", width: 10},
            { header: "% Declining", key: "Diff", width: 10},
            { header: "Phone Number", key: "phoneNumber", width: 10},
            { header: "Email", key: "email", width: 15},
          ],
          "rows": this.LSMList,
          "isRow": 0,
          frozen:true,
        }
      ],
      "fileName": fileName
    };

    this.commonService.downloadAsExcel(worksheetData).then(res => {
      // this.modalReference.close();
      this.buttonLoader = false;
    });
  }

}
